import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import styles from "../../styles/office/OfficeTable.module.css";
import { FaSearch, FaFilter, FaColumns, FaUpload, FaFileDownload, FaChevronDown, FaChevronUp, FaLanguage } from "react-icons/fa";
import { setLanguage, currentLanguage } from '../../services/LanguageTranslationService';
import EditModal from "./EditModal";
import MonthlyReportPDF from './MonthlyReportPDF';
import DailyCashReportPDF from './DailyCashReportPDF';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../assets/image/logo1.png"; // Optional
import PreviousCashReportPDF from './PreviousCashReportPDF';

const initialData = [];
// Language configurations
const LANGUAGE_CONFIG = {
    en: "English",
    mr: "Marathi"
};

// Column configuration - English
const COLUMNS_CONFIG_EN = {
    request_unique_id: { label: "Proposal ID", defaultVisible: true },
    applicantName: { label: "Applicant Name", defaultVisible: true },
    applicantMobile: { label: "Mobile", defaultVisible: false },
    applicantEmail: { label: "Email", defaultVisible: false },
    applicantAddress: { label: "Address", defaultVisible: false },

    updated_date: { label: "Reassigned At", defaultVisible: false },
    pending_at: { label: "Pending From", defaultVisible: false, sortable: true },
    dateOfIssue: { label: "Submission Date", defaultVisible: true, sortable: true },
    dateOfAction: { label: "Date of Approved", defaultVisible: false },

    // division: { label: "Division", defaultVisible: true },
    // district: { label: "District", defaultVisible: false },
    // taluka: { label: "Taluka", defaultVisible: false },
    village: { label: "Village", defaultVisible: false },


    regionalPlanName: { label: "Regional Plan", defaultVisible: false },
    regionalPlanApprovalNumber: { label: "Approval No.", defaultVisible: false },
    regionalPlanApprovalDate: { label: "Approval Date", defaultVisible: false },
    regionalPlanEffectiveDate: { label: "Effective Date", defaultVisible: false },

    surveyNumber: { label: "CTS/Survey No", defaultVisible: true },
    satbaraAttachment: { label: "7-12 Extract", defaultVisible: false },
    meausurementAttachment: { label: "Measurement Sheet", defaultVisible: false },

    PropertyNumberType: { label: "Property Number Type", defaultVisible: false },
    villagePart: { label: "Village Part", defaultVisible: false },
    attachment_pr_satbara: { label: "7/12 Extract", defaultVisible: true },
    attachment_SanctionLayout: { label: "Sanction Layout", defaultVisible: false },
    attachment_MeasurementSheet: { label: "Measurement Sheet", defaultVisible: false },
    attachment_PlotMeasurementMap: { label: "Plot Measurement Map", defaultVisible: false },
    attachment_VillageMap: { label: "Village Map", defaultVisible: false },
    attachment_OldNewSurveyNumberCertificate: { label: "Old/New Survey Number Certificate", defaultVisible: false },

    usageDepartment: { label: "Village Area", defaultVisible: true },
    roadWidth: { label: "Road Width", defaultVisible: false },
    roadType: { label: "Road Type", defaultVisible: false },

    confirm1: { label: "Confirm 1", defaultVisible: false },
    confirm2: { label: "Confirm 2", defaultVisible: false },

    feeReceipt: { label: "Fee Paid", defaultVisible: false },
    feeReceiptdocument: { label: "Fee Recipt", defaultVisible: false },

    certificatename: { label: "Service Type", defaultVisible: true },
    certificatePath: { label: "Document", defaultVisible: true },

    status: { label: "Status", defaultVisible: true },
    remark: { label: "Remark", defaultVisible: false },
    zoneStatementValue: { label: "Zone Statement", defaultVisible: false },

    approved_m_or_a: { label: ' Approved manully or Automatic', defaultVisible: false },
    signature_path: { label: ' Signature_path', defaultVisible: false }
};

// Column configuration - Marathi
const COLUMNS_CONFIG_MR = {

    request_unique_id: { label: "प्रस्ताव क्रमांक", defaultVisible: true },
    // 1️⃣ अर्जदाराची माहिती (सुरुवातीस सोपी ओळख)
    applicantName: { label: "अर्जदाराचे नाव", defaultVisible: true },
    applicantMobile: { label: "मोबाइल", defaultVisible: false },
    applicantEmail: { label: "ईमेल", defaultVisible: false },
    applicantAddress: { label: "पत्ता", defaultVisible: false },


    // 3️⃣ विनंती प्रक्रिया माहिती
    updated_date: { label: "पुनर्नियुक्त तारीख", defaultVisible: false },
    pending_at: { label: "प्रलंबित तारीख", defaultVisible: false },
    dateOfIssue: { label: "सबमिशन तारीख", defaultVisible: true, sortable: true },
    dateOfAction: { label: "कृती तारीख", defaultVisible: false },

    // 4️⃣ स्थानिक माहिती
    // division: { label: "विभाग", defaultVisible: true },
    // district: { label: "जिल्हा", defaultVisible: false },
    // taluka: { label: "तालुका", defaultVisible: false },
    village: { label: "गाव", defaultVisible: false },

    // 5️⃣ प्रादेशिक योजना आणि मंजुरी
    regionalPlanName: { label: "प्रादेशिक योजना", defaultVisible: false },
    regionalPlanApprovalNumber: { label: "मंजुरी क्रमांक", defaultVisible: false },
    regionalPlanApprovalDate: { label: "मंजुरी तारीख", defaultVisible: false },
    regionalPlanEffectiveDate: { label: "प्रभावी तारीख", defaultVisible: false },

    // 6️⃣ जमीन आणि सर्वेक्षण माहिती
    surveyNumber: { label: "सर्व्हे नंबर", defaultVisible: true },
    //areaSqM: { label: "क्षेत्रफळ (m²)", defaultVisible: false },
    satbaraAttachment: { label: "७-१२ उतारा", defaultVisible: true },
    meausurementAttachment: { label: "मोजणी पत्रक", defaultVisible: false },
    usageDepartment: { label: "वापर विभाग", defaultVisible: false },
    roadWidth: { label: "रस्ता रुंदी", defaultVisible: false },
    roadType: { label: "रस्ता प्रकार", defaultVisible: false },

    // 7️⃣ प्रमाणपत्र आणि दस्तऐवज
    certificatename: { label: "सेवा प्रकार", defaultVisible: true },
    certificatePath: { label: "दस्तऐवज", defaultVisible: true },

    // 8️⃣ अंतिम पुष्टीकरण आणि मंजुरी
    confirm1: { label: "पुष्टीकरण १", defaultVisible: false },
    confirm2: { label: "पुष्टीकरण २", defaultVisible: false },

    // 9️⃣ फी आणि स्थिती
    feeReceipt: { label: "फी भरली", defaultVisible: false },
    feeReceiptdocument: { label: "फी भरली", defaultVisible: false },
    status: { label: "स्थिती", defaultVisible: true },
    remark: { label: "शेरा", defaultVisible: false },
    zoneStatementValue: { label: "Zone Statement", defaultVisible: false },
    approved_m_or_a: { label: ' Approved manully or Automatic', defaultVisible: false },
    signature_path: { label: ' Signature_path', defaultVisible: false }
};


// Filter options organized by category - English
const FILTER_OPTIONS_EN = {
    villageArea: [
        { value: "Sangli", label: "Sangli" },
        { value: "Miraj", label: "Miraj" },
        { value: "Kupwad", label: "Kupwad" },
    ],
    status: [
        { value: "approved", label: "Approved" },
        { value: "sendforauthorization", label: "Send for Authorization" },
        { value: "sendbackforreview", label: "Send Back for Review" },
        { value: "pending", label: "Pending" },
        { value: "sendforauthorizationmanully", label: "Send Authorization Manully" },
        { value: "sendforauthorizationautomatically", label: "Send Authorization Automatically" },
        { value: "reassigned", label: "Reassigned" }
    ],
    date: [
        { value: "today", label: "Today" },
        { value: "yesterday", label: "Yesterday" },
        { value: "this_month", label: "This Month" }
    ],
    ServiceType: [
        { value: "zone", label: "Zone Certificate" },
        { value: "part_plan", label: "Part Plan" }
    ]
};

// Filter options organized by category - Marathi
const FILTER_OPTIONS_MR = {
    status: [
        { value: "approved", label: "Approved" },
        { value: "sendforauthorization", label: "Send for Authorization" },
        { value: "sendbackforreview", label: "Send Back for Review" },
        { value: "pending", label: "Pending" },
        { value: "sendforauthorizationmanully", label: "Send Authorization Manully" },
        { value: "sendforauthorizationautomatically", label: "Send Authorization Automatically" },
        { value: "reassigned", label: "Reassigned" }
    ],
    date: [
        { value: "today", label: "आज" },
        { value: "yesterday", label: "काल" },
        { value: "this_month", label: "या महिन्यात" }
    ],
    ServiceType: [
        { value: "zone", label: "झोन प्रमाणपत्र" },
        { value: "part_plan", label: "भाग योजना " }
    ]
};

// Text content for UI elements
const UI_TEXT = {
    en: {
        searchPlaceholder: "Search by name, mobile, or survey no...",
        noResultsTitle: "No applications found",
        noResultsDescription: (hasSearch) => hasSearch
            ? "Try adjusting your search or filter criteria"
            : "There are currently no applications to display",
        showAll: "Show All Applications",
        language: "Language",
        filter: "Filter",
        columns: "Columns",
        statusSummary: "Approved {approvedCount}/{totalCount}"
    },
    mr: {
        searchPlaceholder: "नाव, मोबाइल किंवा सर्व्हे नंबर द्वारे शोधा...",
        noResultsTitle: "कोणतेही अर्ज सापडले नाहीत",
        noResultsDescription: (hasSearch) => hasSearch
            ? "आपली शोध किंवा फिल्टर निकष समायोजित करण्याचा प्रयत्न करा"
            : "सध्या दाखवण्यासाठी कोणतेही अर्ज उपलब्ध नाहीत",
        showAll: "सर्व अर्ज दाखवा",
        language: "भाषा",
        filter: "फिल्टर",
        columns: "स्तंभ",
        statusSummary: "मंजूर {approvedCount}/{totalCount}"
    }
};

const OfficeTable = () => {
    // State management
    const [searchQuery, setSearchQuery] = useState("");
    const [tableData, setTableData] = useState(initialData);
    const [isLoading, setIsLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [activeFilters, setActiveFilters] = useState([]);
    const [columnVisibility, setColumnVisibility] = useState(
        Object.keys(COLUMNS_CONFIG_EN).reduce((acc, key) => {
            acc[key] = COLUMNS_CONFIG_EN[key].defaultVisible;
            return acc;
        }, {})
    );

    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [language] = useState(currentLanguage);
    const [showLanguageMenu, setShowLanguageMenu] = useState(false);
    const [totalApplications, setTotalApplications] = useState(0);
    const [totalApprovedApplications, setTotalApprovedApplications] = useState(0);
    const [officerProfile, setOfficerProfile] = useState(null);
    const [signPath, setSignPath] = useState(null);
    const [activeDropdown, setActiveDropdown] = useState(null); // 'filter', 'language',

    // Get current language configurations
    const currentLanguageConfig = useMemo(() => ({
        columns: language === 'en' ? COLUMNS_CONFIG_EN : COLUMNS_CONFIG_MR,
        filters: language === 'en' ? FILTER_OPTIONS_EN : FILTER_OPTIONS_MR,
        uiText: UI_TEXT[language]
    }), [language]);

    // Refs for dropdown containers
    const filterRef = useRef(null);
    const languageRef = useRef(null);
    const villageAreaRef = useRef(null);
    const columnsRef = useRef(null);
    const reportRef = useRef(null);
    const token = localStorage.getItem("token_office");

    //to download report
    const pdfRef = useRef();
    const pdfRefPre = useRef();


    const [reportInfo, setReportInfo] = useState({
        location: "Baramati, Pune",
        officeName: "",
        branchName: "",
        district: "",
        month: "",
        year: "",
    });

    const [reportInfoPre, setReportInfoPre] = useState({
        location: "Baramati, Pune",
        officeName: "",
        branchName: "",
        district: "",
        month: "",
        year: "",
    });

    const [tableData_report, settableData_report] = useState([
        [1, "Zone Certificate", "7 Days", 12, 5, 17, 10, 2, 5, 1, 1],
        [2, "Part Plan", "3 Days", 7, 10, 17, 15, 1, 1, 0, 0],
    ]);

    const [tableData_report_prev, settableData_report_prev] = useState([
        [1, "Zone Certificate", "7 Days", 12, 5, 17, 10, 2, 5, 1, 1],
        [2, "Part Plan", "3 Days", 7, 10, 17, 15, 1, 1, 0, 0],
    ]);


    const handleDownload = (data) => {

        if (data == "previous") {
            if (pdfRefPre.current) {
                pdfRefPre.current.generatePDF();
            }
            //setTableData_report_send(tableData_report_prev);
        }

        if (data == "current") {
            if (pdfRef.current) {
                pdfRef.current.generatePDF();
            }
            // setTableData_report_send(tableData_report);
        }

    };

    // Add with other refs
    const previousDayCashReportRef = useRef();
    const previousMonthCashReportRef = useRef();
    const dailyCashReportRef = useRef();

    // Update this function in your OfficeTable component
    const fetchDailyCashReportDataold = async (date = null) => {
        try {
            const reportDate = date || new Date().toISOString().split('T')[0];
            console.log("Fetching daily cash report for date:", reportDate);

            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_daily_cash_report.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ date: reportDate }),
                credentials: "include",
            });

            const result = await response.json();
            console.log("API Response:", result);

            if (result.status === "success") {
                // Map the API response to match PDF component structure
                const formattedData = {
                    date: result.data.date || new Date(reportDate).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    }),
                    zone: {
                        count: result.data.zone.count || 0,
                        // Map records to match expected format
                        records: (result.data.zone.records || []).map(record => ({
                            appId: record.appId || record.request_unique_id,
                            name: record.name || record.applicant_name,
                            payment_mode: record.payment_mode,
                            status: record.status
                        }))
                    },
                    partplan: {
                        count: result.data.partplan.count || 0,
                        // Map records to match expected format
                        records: (result.data.partplan.records || []).map(record => ({
                            appId: record.appId || record.request_unique_id,
                            name: record.name || record.applicant_name,
                            payment_mode: record.payment_mode,
                            status: record.status
                        }))
                    },
                    payment: {
                        online: {
                            count: result.data.payment.online.count || 0,
                            amount: result.data.payment.online.amount || 0
                        },
                        cash: {
                            count: result.data.payment.cash.count || 0,
                            amount: result.data.payment.cash.amount || 0
                        }
                    },
                    remarks: result.data.remarks || "Daily cash report generated successfully."
                };

                console.log("Formatted Data for PDF:", formattedData);
                return formattedData;
            } else {
                console.error("Failed to fetch daily cash report:", result.message);
                return null;
            }
        } catch (error) {
            console.error("Error fetching daily cash report:", error);
            return null;
        }
    };

    // Update the fetchDailyCashReportData function to handle previous dates
    const fetchDailyCashReportData = async (date = null, reportType = 'current') => {
        try {
            let reportDate = date;
            let endpoint = `${process.env.REACT_APP_SERVER_URL}/get_daily_cash_report.php`;

            if (reportType === 'previous_day' || reportType === 'previous_month') {
                endpoint = `${process.env.REACT_APP_SERVER_URL}/get_previous_cash_report.php`;
            } else {
                reportDate = reportDate || new Date().toISOString().split('T')[0];
            }

            console.log(`Fetching ${reportType} report for:`, reportDate);

            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    date: reportDate,
                    report_type: reportType
                }),
                credentials: "include",
            });

            const result = await response.json();
            console.log("API Response:", result);

            if (result.status === "success") {
                // Format the data to match PDF component structure
                const formattedData = {
                    date: result.data.date || new Date(reportDate).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    }),
                    zone: {
                        count: result.data.zone.count || 0,
                        records: (result.data.zone.records || []).map(record => ({
                            appId: record.appId || record.request_unique_id,
                            name: record.name || record.applicant_name,
                            payment_mode: record.payment_mode,
                            status: record.status
                        }))
                    },
                    partplan: {
                        count: result.data.partplan.count || 0,
                        records: (result.data.partplan.records || []).map(record => ({
                            appId: record.appId || record.request_unique_id,
                            name: record.name || record.applicant_name,
                            payment_mode: record.payment_mode,
                            status: record.status
                        }))
                    },
                    payment: {
                        online: {
                            count: result.data.payment.online.count || 0,
                            amount: result.data.payment.online.amount || 0
                        },
                        cash: {
                            count: result.data.payment.cash.count || 0,
                            amount: result.data.payment.cash.amount || 0
                        }
                    },
                    remarks: result.data.remarks || "Report generated successfully."
                };

                console.log("Formatted Data for PDF:", formattedData);
                return formattedData;
            } else {
                console.error("Failed to fetch report:", result.message);
                return null;
            }
        } catch (error) {
            console.error("Error fetching report:", error);
            return null;
        }
    };

    // Add handler for previous day cash report
    const handlePreviousDayCashReport = async () => {
        try {
            setIsLoading(true);
            console.log("Starting previous day cash report generation...");

            // Calculate previous day date
            const today = new Date();
            const previousDay = new Date(today);
            previousDay.setDate(today.getDate() - 1);
            const previousDayStr = previousDay.toISOString().split('T')[0];

            // Fetch real data from API
            const realData = await fetchDailyCashReportData(previousDayStr, 'previous_day');

            if (realData) {
                console.log("Previous day data fetched successfully:", realData);

                if (previousDayCashReportRef.current) {
                    previousDayCashReportRef.current.generatePDF(realData, 'previous_day');
                }
            } else {
                // Fallback to sample data if API fails
                const previousDayFormatted = previousDay.toLocaleDateString('en-IN', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                });

                const sampleData = {
                    date: previousDayFormatted,
                    zone: {
                        count: 2,
                        records: [
                            { appId: "ZON101", name: "Sample Zone 1", payment_mode: "online", status: "approved" },
                            { appId: "ZON102", name: "Sample Zone 2", payment_mode: "cash", status: "approved" },
                        ],
                    },
                    partplan: {
                        count: 1,
                        records: [
                            { appId: "PP101", name: "Sample Part Plan 1", payment_mode: "online", status: "approved" },
                        ],
                    },
                    payment: {
                        online: { count: 2, amount: 1700 },
                        cash: { count: 1, amount: 300 },
                    },
                    remarks: "Sample data - Previous day report (fallback)",
                };

                if (previousDayCashReportRef.current) {
                    previousDayCashReportRef.current.generatePDF(sampleData, 'previous_day');
                }
            }
        } catch (error) {
            console.error("Error generating previous day cash report:", error);
            alert("Error generating report. Please try again.");
        } finally {
            setIsLoading(false);
            setActiveDropdown(null);
        }
    };

    // Add handler for previous month cash report
    const handlePreviousMonthCashReport = async () => {
        try {
            setIsLoading(true);
            console.log("Starting previous month cash report generation...");

            // Calculate previous month
            const today = new Date();
            const previousMonth = new Date(today);
            previousMonth.setMonth(today.getMonth() - 1);

            // Use first day of previous month as reference
            const previousMonthRef = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), 1);
            const previousMonthRefStr = previousMonthRef.toISOString().split('T')[0];

            // Fetch real data from API
            const realData = await fetchDailyCashReportData(previousMonthRefStr, 'previous_month');

            if (realData) {
                console.log("Previous month data fetched successfully:", realData);

                if (previousMonthCashReportRef.current) {
                    previousMonthCashReportRef.current.generatePDF(realData, 'previous_month');
                }
            } else {
                // Fallback to sample data if API fails
                const monthNames = [
                    "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                const previousMonthName = monthNames[previousMonth.getMonth()];
                const previousMonthYear = previousMonth.getFullYear();

                const sampleData = {
                    date: `${previousMonthName} ${previousMonthYear}`,
                    zone: {
                        count: 15,
                        records: Array(15).fill().map((_, i) => ({
                            appId: `ZON${200 + i}`,
                            name: `Sample Zone Applicant ${i + 1}`,
                            payment_mode: i % 3 === 0 ? "online" : "cash",
                            status: "approved"
                        })),
                    },
                    partplan: {
                        count: 8,
                        records: Array(8).fill().map((_, i) => ({
                            appId: `PP${200 + i}`,
                            name: `Sample Part Plan Applicant ${i + 1}`,
                            payment_mode: i % 2 === 0 ? "online" : "cash",
                            status: "approved"
                        })),
                    },
                    payment: {
                        online: { count: 12, amount: 9600 },
                        cash: { count: 11, amount: 5100 },
                    },
                    remarks: `Sample data - Previous month report for ${previousMonthName} ${previousMonthYear} (fallback)`,
                };

                if (previousMonthCashReportRef.current) {
                    previousMonthCashReportRef.current.generatePDF(sampleData, 'previous_month');
                }
            }
        } catch (error) {
            console.error("Error generating previous month cash report:", error);
            alert("Error generating report. Please try again.");
        } finally {
            setIsLoading(false);
            setActiveDropdown(null);
        }
    };

    // Update the handleDownloadDailyCashReport function with better logging
    const handleDownloadDailyCashReport = async () => {
        try {
            setIsLoading(true);
            console.log("Starting daily cash report generation...");

            // Fetch real data from API
            const realData = await fetchDailyCashReportData();

            if (realData) {
                console.log("Real data fetched successfully:", realData);

                // Check if we have records
                console.log("Zone records count:", realData.zone.records.length);
                console.log("Part Plan records count:", realData.partplan.records.length);

                // Debug: Log first few records
                if (realData.zone.records.length > 0) {
                    console.log("First zone record:", realData.zone.records[0]);
                }
                if (realData.partplan.records.length > 0) {
                    console.log("First part plan record:", realData.partplan.records[0]);
                }

                // Trigger PDF generation with real data
                if (dailyCashReportRef.current) {
                    console.log("Calling PDF generation...");
                    dailyCashReportRef.current.generatePDF(realData);
                } else {
                    console.error("PDF ref not available");
                }
            } else {
                console.log("Using sample data as fallback");
                // Fallback to sample data if API fails
                const sampleData = {
                    date: new Date().toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    }),
                    zone: {
                        count: 3,
                        records: [
                            { appId: "ZON001", name: "Rahul Patil", payment_mode: "online" },
                            { appId: "ZON002", name: "Amit Shinde", payment_mode: "cash" },
                            { appId: "ZON003", name: "Priya Deshmukh", payment_mode: "cash" },
                        ],
                    },
                    partplan: {
                        count: 2,
                        records: [
                            { appId: "PP001", name: "Sneha Kulkarni", payment_mode: "online" },
                            { appId: "PP002", name: "Prashant Jadhav", payment_mode: "cash" },
                        ],
                    },
                    payment: {
                        online: { count: 25, amount: 14500 },
                        cash: { count: 7, amount: 2900 },
                    },
                    remarks: "Sample data - All transactions completed successfully.",
                };

                if (dailyCashReportRef.current) {
                    dailyCashReportRef.current.generatePDF(sampleData);
                }
            }
        } catch (error) {
            console.error("Error generating daily cash report:", error);
            alert("Error generating report. Please try again.");
        } finally {
            setIsLoading(false);
            setActiveDropdown(null);
        }
    };
    // Update the handleDownloadDailyCashReport function

    useEffect(() => {
        const fetchOfficeProfile = async () => {
            try {
                //const token = localStorage.getItem("token_office"); // Assuming token is stored in localStorage
                const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_office_profile.php`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    credentials: "include",
                });

                const result = await response.json();

                if (result.status === "success") {
                    const currentDate = new Date();
                    const monthNames = [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                    ];

                    // Get previous month date
                    const prevMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);


                    setOfficerProfile(result.profile.profile);
                    if (result.profile.profile === "Authorizer") {
                        setActiveFilters(["sendforauthorization", "sendforauthorizationmanully", "sendforauthorizationautomatically"]);
                        setSignPath(result.profile.signature_path);
                    }

                    setReportInfo({
                        location: `${result.profile.district || "Baramati"}, ${result.profile.division || "Pune"}`,
                        officeName: "Assistant Director of Town Planning",
                        branchName: result.profile.office_name || "", // adjust if branch name is different
                        district: result.profile.district || "",
                        month: monthNames[currentDate.getMonth()],
                        year: currentDate.getFullYear().toString(),
                    });

                    setReportInfoPre({
                        location: `${result.profile.district || "Baramati"}, ${result.profile.division || "Pune"}`,
                        officeName: "Assistant Director of Town Planning",
                        branchName: result.profile.office_name || "", // adjust if branch name is different
                        district: result.profile.district || "",
                        month: monthNames[prevMonthDate.getMonth()],
                        year: prevMonthDate.getFullYear().toString(),
                    });

                    const formattedData_current = result.count.map((item, index) => {
                        let durationDisplay;

                        if (item.certification_type == "Zone") {
                            durationDisplay = "7 days";
                        } else if (item.certification_type == "Part Plan") {
                            durationDisplay = "3 days";
                        } else {
                            durationDisplay = item.duration || "N/A";
                        }

                        return [
                            index + 1,
                            item.certification_type || "N/A",
                            durationDisplay,
                            Number(item.pending_before_current_month) || 0,
                            Number(item.received_current_month) || 0,
                            Number((Number(item.pending_before_current_month) || 0) + (Number(item.received_current_month) || 0)),
                            Number(item.approved_within_3_days) || 0,
                            Number(item.approved_after_3_days) || 0,
                            Number(item.pending_current_month) || 0,
                            Number(item.rejected_current_month) || 0,
                            Number(item.appeal) || 0
                        ];
                    });


                    settableData_report(formattedData_current);

                    const formattedData_prev = result.count.map((item, index) => {
                        let durationDisplay;

                        if (item.certification_type == "Zone") {
                            durationDisplay = "7 days";
                        } else if (item.certification_type == "Part Plan") {
                            durationDisplay = "3 days";
                        } else {
                            durationDisplay = item.duration || "N/A";
                        }


                        return [
                            index + 1,
                            item.certification_type || "N/A",
                            durationDisplay,
                            Number(item.pending_before_previous_month) || 0,
                            Number(item.received_previous_month) || 0,
                            Number((Number(item.pending_before_previous_month) || 0) + (Number(item.received_previous_month) || 0)),
                            Number(item.approved_within_3_days_prev) || 0,
                            Number(item.approved_after_3_days_prev) || 0,
                            Number(item.pending_previous_month) || 0,
                            Number(item.rejected_previous_month) || 0,
                            Number(item.appeal) || 0
                        ];
                    });
                    settableData_report_prev(formattedData_prev);
                } else {
                    console.error("Failed to fetch profile:", result.message);
                }
            } catch (error) {
                console.error("Error fetching office profile:", error);
            }
        };

        fetchOfficeProfile();
    }, []);



    // Fetch application data
    useEffect(() => {
        const fetchApplicationData = async () => {
            try {
                setIsLoading(true);

                const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/fetch_requests.php`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    //body: formData, // Make sure `formData` is a valid FormData object
                    credentials: 'include'
                });

                const result = await response.json();

                const formattedData = result.data.map((application) => ({
                    //updated_date: application.updated_at,
                    PropertyNumberType: application.PropertyNumberType || null,
                    villagePart: application.villagePart || null,
                    attachment_pr_satbara: application.attachment_pr_satbara || null,
                    attachment_SanctionLayout: application.attachment_SanctionLayout || null,
                    attachment_MeasurementSheet: application.attachment_MeasurementSheet || null,
                    attachment_PlotMeasurementMap: application.attachment_PlotMeasurementMap || null,
                    attachment_VillageMap: application.attachment_VillageMap || null,
                    attachment_OldNewSurveyNumberCertificate: application.attachment_OldNewSurveyNumberCertificate || null,

                    updated_date: application.status === "rejected" ? application.updated_at : "N/A",
                    remark: application.remark,
                    request_unique_id: application.request_unique_id || "N/A",
                    senderID: application.sender_unique_id || "N/A",
                    reciverID: application.receiver_unique_id || "N/A",
                    dateOfIssue: application.created_at || "N/A",
                    dateOfAction: application.approved_at || "N/A",
                    id: application.id || "N/A",
                    division: application.division || "N/A",
                    district: application.district || "N/A",
                    taluka: application.taluka || "N/A",
                    village: application.village || "N/A",
                    applicantName: application.applicant_name || "N/A",
                    applicantAddress: application.applicant_address || "N/A",
                    applicantMobile: application.applicant_phone || "N/A",
                    applicantEmail: application.applicant_email || "N/A",
                    regionalPlanName: application.regional_plan_name || "N/A",
                    regionalPlanApprovalNumber: application.regional_plan_approval_notification_number || "N/A",
                    regionalPlanApprovalDate: application.regional_plan_approval_date || "N/A",
                    regionalPlanEffectiveDate: application.implementation_date || "N/A",
                    surveyNumber: application.survey_no || "N/A",
                    areaSqM: application.area || "N/A",
                    satbaraAttachment: application.attachment_path || null,
                    meausurementAttachment: application.measurement_attachment_path || null,
                    usageDepartment: application.question1 || "N/A",
                    roadWidth: application.question2 || "N/A",
                    roadType: application.question3 || "N/A",
                    certificatePath: application.upload_certificate_path || null,
                    certificatename: application.certification_name || "N/A",
                    confirm1: application.confirm1 || false,
                    confirm2: application.confirm2 || false,
                    feeReceiptdocument: application.payment_receipt || null,
                    utrChequeNo: application.utrChequeNo || null,
                    paymentDate: application.payment_received_date || null,
                    grnNumber: application.grn_number || null,
                    paymentVerified: application.payment_verified || null,
                    status: application.status || "Pending",
                    pending_at: application.pending_at || null,
                    zoneStatementValue: application.zone_statement_value || null,
                    approved_m_or_a: application.approved_m_or_a || null,
                    signature_path: application.signature_path || null,
                }));

                // Get total count of applications
                const totalApplications = result.data.length;
                const TotalApprovedApplications = result.data.filter(app => app.status === "approved" || app.status === 'approvemanully' || app.status === 'approveautomatically').length;
                setTotalApplications(totalApplications);
                setTotalApprovedApplications(TotalApprovedApplications);
                setTableData(formattedData);
            } catch (error) {
                console.error("Error loading application data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchApplicationData();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (activeDropdown) {
                let shouldClose = true;

                // Check if click was inside any dropdown
                if (filterRef.current && filterRef.current.contains(event.target)) {
                    shouldClose = false;
                }
                if (languageRef.current && languageRef.current.contains(event.target)) {
                    shouldClose = false;
                }
                if (villageAreaRef.current && villageAreaRef.current.contains(event.target)) {
                    shouldClose = false;
                }
                if (columnsRef.current && columnsRef.current.contains(event.target)) {
                    shouldClose = false;
                }
                if (reportRef.current && reportRef.current.contains(event.target)) {
                    shouldClose = false;
                }

                if (shouldClose) {
                    setActiveDropdown(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [activeDropdown]);

    // Update the dropdown toggle functions to use the new activeDropdown state
    const toggleFilterMenu = useCallback(() => {
        setActiveDropdown(prev => prev === 'filter' ? null : 'filter');
    }, []);

    const toggleLanguageMenu = useCallback(() => {
        setActiveDropdown(prev => prev === 'language' ? null : 'language');
    }, []);


    const toggleVillageAreaMenu = useCallback(() => {
        setActiveDropdown(prev => prev === 'villageArea' ? null : 'villageArea');
    }, []);



    const toggleColumnsMenu = useCallback(() => {
        setActiveDropdown(prev => prev === 'columns' ? null : 'columns');
    }, []);

    const toggleReportMenu = useCallback(() => {
        setActiveDropdown(prev => prev === 'report' ? null : 'report');
    }, []);


    const displayApplications = useMemo(() => {
        if (!tableData.length) return [];

        const currentDate = new Date().toISOString().split("T")[0];
        const previousDate = new Date(new Date().setDate(new Date().getDate() - 1))
            .toISOString()
            .split("T")[0];
        const currentMonth = new Date().toISOString().slice(0, 7);

        return tableData
            .filter((application) => {
                // 🔍 Search filter
                const matchesSearch =
                    application.applicantName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    application.applicantMobile.includes(searchQuery) ||
                    application.surveyNumber.toLowerCase().includes(searchQuery.toLowerCase());

                if (!matchesSearch) return false;

                // ✅ If no filters are selected, show all
                if (activeFilters.length === 0) return true;

                const appDate = application.dateOfIssue.split(" ")[0];
                const certName = application.certificatename.toLowerCase().replace(/\s+/g, "_");
                const status = application.status.toLowerCase();



                // 🗂️ Group filters
                const statusFilters = activeFilters.filter(f =>
                    ["pending", "approved", "rejected", "sendforauthorization", "sendbackforreview", "sendforauthorizationmanully", "sendforauthorizationautomatically", 'approveautomatically', 'approvemanully'].includes(f)
                );
                const serviceFilters = activeFilters.filter(f =>
                    ["zone", "part_plan"].includes(f)
                );
                const dateFilters = activeFilters.filter(f =>
                    ["today", "yesterday", "this_month"].includes(f)
                );

                const villageAreaFilters = activeFilters.filter(f =>
                    ["Sangli", "Miraj", "Kupwad"].includes(f)   // or read from FILTER_OPTIONS_EN.villageArea
                );

                // ✅ Status check (if any selected)
                const matchesStatusold =
                    statusFilters.length === 0 || statusFilters.some(f => f === status);


                const matchesVillageArea = villageAreaFilters.length === 0 ||
                    villageAreaFilters.some(v => v === application.usageDepartment);


                // ✅ Status check (if any selected)
                const matchesStatus =
                    statusFilters.length === 0 ||
                    statusFilters.some(f => {
                        if (f === "approved") {
                            // when filter is 'approved', include both 'approveautomatically' and 'approvemanully'
                            return (
                                status === "approveautomatically" ||
                                status === "approvemanully"
                            );
                        }
                        // otherwise, match directly
                        return f === status;
                    });

                // ✅ Service type check (if any selected)
                const matchesService =
                    serviceFilters.length === 0 || serviceFilters.some(f => f === certName);


                // ✅ Date check (if any selected)
                const matchesDate =
                    dateFilters.length === 0 ||
                    dateFilters.some(f => {
                        switch (f) {
                            case "today": return appDate === currentDate;
                            case "yesterday": return appDate === previousDate;
                            case "this_month": return appDate.slice(0, 7) === currentMonth;
                            default: return false;
                        }
                    });

                return matchesStatus && matchesService && matchesDate && matchesVillageArea;
            })
            .sort((a, b) => {
                if (!sortConfig.key) return 0;
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === "asc" ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === "asc" ? 1 : -1;
                }
                return 0;
            });
    }, [tableData, searchQuery, activeFilters, sortConfig]);



    // Handlers desc 
    const requestSort = useCallback((key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    }, []);



    const updateActiveFilters = useCallback((category, value) => {
        setActiveFilters(prev => {
            // Remove any existing filters from the same category
            const otherCategoryFilters = prev.filter(filter => {
                // Check if the filter belongs to a different category
                const isDateFilter = ['today', 'yesterday', 'this_month'].includes(filter);
                const isStatusFilter = ['pending', 'approved', 'rejected'].includes(filter);
                const isServiceTypeFilter = ['zone', 'part_plan'].includes(filter);

                if (category === 'date' && !isDateFilter) return true;
                if (category === 'status' && !isStatusFilter) return true;
                if (category === 'ServiceType' && !isServiceTypeFilter) return true;
                return false;
            });

            // Add the new filter if it's not "all"
            return value === "all" ? otherCategoryFilters : [...otherCategoryFilters, value];
        });
    }, []);


    const updateActiveFiltersCheckbox = useCallback((category, value) => {
        setActiveFilters(prev => {
            // ✅ Toggle: if value already exists, remove it; otherwise add it
            if (prev.includes(value)) {
                return prev.filter(filter => filter !== value);
            } else {
                return [...prev, value];
            }
        });
    }, []);


    const toggleColumn = useCallback((column) => {
        setColumnVisibility(current => ({
            ...current,
            [column]: !current[column]
        }));
    }, []);

    const openRecordDetails = useCallback((record) => {
        setSelectedRecord(record);
        setIsEditModalOpen(true);
    }, []);

    const closeEditModal = useCallback(() => {
        setIsEditModalOpen(false);
        setSelectedRecord(null);
    }, []);

    const saveRecordChanges = useCallback(async (formData) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/officeRequestAction.php`,
                {
                    method: "POST",
                    body: formData,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                // Update the table data with the new data
                setTableData(current => current.map(record =>
                    record.id === formData.get("id") ? {
                        ...record,
                        status: formData.get("status"),
                        regionalPlanName: formData.get("regionalPlanName"),
                        regionalPlanApprovalNumber: formData.get("regionalPlanApprovalNumber"),
                        regionalPlanApprovalDate: formData.get("regionalPlanApprovalDate"),
                        regionalPlanEffectiveDate: formData.get("regionalPlanEffectiveDate"),
                        usageDepartment: formData.get("usageDepartment"),
                        roadWidth: formData.get("roadWidth"),
                        roadType: formData.get("roadType"),
                        remark: formData.get("remark"),
                        // Update certificate path if a new file was uploaded
                        certificatePath: result.filePath || record.certificatePath
                    } : record
                ));
                // Don't close modal here, let EditModal handle it
                return result; // Return result to indicate success
            } else {
                console.error("Status update failed:", result.message);
                throw new Error(result.message || (language === 'en' ? 'Update failed' : 'अद्यतन अयशस्वी'));
            }
        } catch (error) {
            console.error("Error updating record:", error);
            throw error; // Re-throw to be caught in EditModal
        }
    }, [language, token]);

    const changeLanguage = useCallback((lang) => {
        setLanguage(lang);
        // setShowLanguageMenu(false);
    }, []);

    // Helper functions
    const formatDate = useCallback((dateString) => {

        if (!dateString || dateString === "N/A") return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString(language === 'en' ? 'en-IN' : 'mr-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    }, [language]);
    // Helper functions

    const getStatusBadgeClass = useCallback((status, createdAt, updatedAt) => {
        switch (status.toLowerCase()) {
            case 'approved':
                return styles.approved;
            case 'approvemanully':
                return styles.approved;
            case 'approveautomatically':
                return styles.approved;
            case 'rejected':
                return styles.rejected;
            case 'reassigned':
                return styles.rejected;
            case 'pending':
                const created = new Date(createdAt);
                const updated = new Date(updatedAt);

                return updated > created ? styles.glowpending : styles.pending;
            default:
                return styles.pending;
        }
    }, []);

    // Render functions
    const renderTableHeader = () => (
        <thead>
            <tr>
                <th>#</th>
                {Object.entries(currentLanguageConfig.columns).map(([key, config]) =>
                    columnVisibility[key] && (
                        <th
                            key={key}
                            className={config.sortable ? styles.sortable : ''}
                            onClick={config.sortable ? () => requestSort(key) : undefined}
                        >
                            {config.label}
                            {config.sortable && sortConfig.key === key && (
                                <span className={`${styles.sortIcon} ${sortConfig.direction === 'asc' ? '' : styles.asc}`}>
                                    <FaChevronDown size={12} />
                                </span>
                            )}
                        </th>
                    )
                )}
            </tr>
        </thead>
    );

    const renderTableBody = () => (
        <tbody>
            {displayApplications.map((application, index) => {

                return (
                    <tr key={application.id} className={styles.tableRow}>
                        <td>{index + 1}</td>
                        {Object.keys(currentLanguageConfig.columns).map(key =>
                            columnVisibility[key] && (
                                <td
                                    key={key}
                                    onClick={() => handleCellClick(key, application)}
                                    className={getCellClass(key)}
                                >

                                    {renderTableCell(key, application)}
                                </td>
                            )
                        )}
                    </tr>
                );
            })}
        </tbody>
    );


    const handleCellClick = (key, application) => {
        if (key === 'request_unique_id') {

            openRecordDetails(application);
        }
    };

    const getCellClass = (key) => {
        if (key === 'request_unique_id') return styles.clickableCell;

        return '';
    };


    const renderTableCell = (key, application) => {
        const value = application[key];
        const isEn = language === 'en';
        switch (key) {
            case 'updated_date':

            case 'pending_at':
            case 'dateOfIssue':
            case 'dateOfAction':
            case 'regionalPlanApprovalDate':
            case 'regionalPlanEffectiveDate':
                return formatDate(application[key]);  // Removed <td> wrapper

            case 'certificatename':
                return value === 'Zone'
                    ? (isEn ? 'Zone' : 'झोन')
                    : value === 'Part Plan'
                        ? (isEn ? 'Part Plan' : 'भाग योजना')
                        : value;  // Removed <td> wrapper

            case 'attachment_pr_satbara':
                return application[key] ? (
                    <a
                        href={`${process.env.REACT_APP_SERVER_URL}/${application[key]}`}
                        download
                        className={styles.fileLink}
                    >
                        <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
                    </a>
                ) : "N/A";  // Removed <td> wrapper


            case 'satbaraAttachment':
                return application[key] ? (
                    <a
                        href={`${process.env.REACT_APP_SERVER_URL}/${application[key]}`}
                        download
                        className={styles.fileLink}
                    >
                        <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
                    </a>
                ) : "N/A";  // Removed <td> wrapper



            // Similarly update all other cases to remove the <td> wrappers
            case 'meausurementAttachment':
                return application[key] ? (
                    <a
                        href={`${process.env.REACT_APP_SERVER_URL}/${application[key]}`}
                        download
                        className={styles.fileLink}
                    >
                        <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
                    </a>
                ) : "N/A";


            case 'certificatePath':
                return application[key] ? (
                    <a
                        className={styles.uploadButton}
                        href={`${process.env.REACT_APP_SERVER_URL}/${application[key]}`}
                        download
                    >
                        <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
                    </a>
                ) : (
                    (application['status'] === 'approved' || application['status'] === 'approveautomatically' || application['status'] === 'approvemanully') ? (

                        <a
                            className={styles.uploadButton}
                            onClick={() => openRecordDetails(application)}

                        >
                            <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
                        </a>

                    ) : (
                        <label
                            className={styles.uploadButton}
                            onClick={() => openRecordDetails(application)}
                        >
                            <FaUpload /> {language === 'en' ? 'Upload' : 'अपलोड'}
                        </label>
                    )
                );

            case 'status':
                const statusLabel = language === 'en'
                    ? (application.status === "pending" ? "Pending"
                        : application.status === "approved" ? "Approved"
                            : application.status === "rejected" ? "Rejected"
                                : application.status === "sendbackforreview" ? "Sent Back for Review"
                                    : application.status === "sendforauthorization" ? "Sent for Authorization"
                                        : application.status === "sendforauthorizationmanully" ? "Pending for Authorization"
                                            : application.status === "sendforauthorizationautomatically" ? "Pending for Authorization"
                                                : application.status === "reassigned" ? "Reassigned"
                                                    : application.status === "approveautomatically" ? "Approved"
                                                        : application.status === "approvemanully" ? "Approved"
                                                            : "Unknown")
                    : (application.status === "pending" ? "प्रलंबित"
                        : application.status === "approved" ? "मंजूर"
                            : application.status === "rejected" ? "नाकारले"
                                : application.status === "sendbackforreview" ? "पुनरावलोकनासाठी परत पाठवा"
                                    : application.status === "sendforauthorization" ? "मंजुरीसाठी पाठवा"
                                        : "अज्ञात");

                return (
                    <span className={`${styles.statusBadge} ${getStatusBadgeClass(application.status, application.dateOfIssue, application.updated_date)}`}>
                        {statusLabel}
                    </span>
                );


            case 'confirm1':
            case 'confirm2':
            case 'feeReceipt':
                return application[key] ? (language === 'en' ? "Yes" : "होय") : (language === 'en' ? "No" : "नाही");

            default:
                return application[key];
        }
    };

    const renderFilterMenu = useCallback(() => (
        <div
            ref={filterRef}
            className={`${styles.dropdownContent} ${activeDropdown === 'filter' ? styles.show : ''}`}
        >
            {Object.entries(currentLanguageConfig.filters).map(([category, options]) => (
                <div key={category} className={styles.dropdownSection}>
                    <span className={styles.dropdownSectionTitle}>
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                    </span>
                    {options.map(option => (
                        <label key={option.value} className={styles.dropdownItem}>
                            <input
                                type="checkbox"  // ✅ changed radio → checkbox
                                checked={activeFilters.includes(option.value)}
                                onChange={() => updateActiveFiltersCheckbox(category, option.value)} // ✅ same logic works
                            />
                            {option.label}
                        </label>
                    ))}
                </div>
            ))}
            <div className={styles.dropdownItem}>
                <button
                    className={styles.clearFiltersButton}
                    onClick={() => setActiveFilters([])}
                >
                    {language === 'en' ? 'Clear All Filters' : 'सर्व फिल्टर्स साफ करा'}
                </button>
            </div>
        </div>
    ), [activeDropdown, currentLanguageConfig.filters, activeFilters, updateActiveFilters, updateActiveFiltersCheckbox, language]);




    const renderVillageAreaMenu = useCallback(() => (
        <div
            ref={villageAreaRef}
            className={`${styles.dropdownContent} ${activeDropdown === 'villageArea' ? styles.show : ''}`}
        >
            {Object.entries(currentLanguageConfig.filters).map(([category, options]) => (
                <div key={category} className={styles.dropdownSection}>
                    <span className={styles.dropdownSectionTitle}>
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                    </span>
                    {options.map(option => (
                        <label key={option.value} className={styles.dropdownItem}>
                            <input
                                type="checkbox"  // ✅ changed radio → checkbox
                                checked={activeFilters.includes(option.value)}
                                onChange={() => updateActiveFiltersCheckbox(category, option.value)} // ✅ same logic works
                            />
                            {option.label}
                        </label>
                    ))}
                </div>
            ))}
            <div className={styles.dropdownItem}>
                <button
                    className={styles.clearFiltersButton}
                    onClick={() => setActiveFilters([])}
                >
                    {language === 'en' ? 'Clear All Filters' : 'सर्व फिल्टर्स साफ करा'}
                </button>
            </div>

        </div>
    ), [activeDropdown, currentLanguageConfig.filters, activeFilters, updateActiveFilters, updateActiveFiltersCheckbox, language]);


    const renderLanguageMenu = useCallback(() => (
        <div
            ref={languageRef}
            className={`${styles.dropdownContent} ${activeDropdown === 'language' ? styles.show : ''}`}
        >
            <div className={styles.dropdownSection}>
                <span className={styles.dropdownSectionTitle}>
                    {currentLanguageConfig.uiText.language}
                </span>
                {Object.entries(LANGUAGE_CONFIG).map(([code, name]) => (
                    <label
                        key={code}
                        className={styles.dropdownItem}
                        onClick={() => changeLanguage(code)}
                    >
                        <input
                            type="radio"
                            name="language"
                            checked={language === code}
                            onChange={() => changeLanguage(code)}
                        />
                        {name}
                    </label>
                ))}
            </div>

        </div>
    ), [activeDropdown, currentLanguageConfig.uiText, language, changeLanguage]);

    const renderColumnsMenu = useCallback(() => (
        <div
            ref={columnsRef}
            className={`${styles.dropdownContent} ${activeDropdown === 'columns' ? styles.show : ''}`}
        >
            <div className={styles.dropdownSection}>
                <span className={styles.dropdownSectionTitle}>
                    {language === 'en' ? 'Show/Hide Columns' : 'स्तंभ दाखवा/लपवा'}
                </span>
                {Object.entries(currentLanguageConfig.columns).map(([key, config]) => (
                    <label key={key} className={styles.dropdownItem}>
                        <input
                            type="checkbox"
                            checked={columnVisibility[key]}
                            onChange={() => toggleColumn(key)}
                        />
                        {config.label}
                    </label>
                ))}
            </div>
            {/* ... keep existing columns menu content */}
        </div>
    ), [activeDropdown, currentLanguageConfig.columns, columnVisibility, language, toggleColumn]);



    const renderReportMenuold = useCallback(() => (
        <div
            ref={reportRef}
            className={`${styles.dropdownContent} ${activeDropdown === 'report' ? styles.show : ''}`}
        >
            <div className={styles.dropdownSection}>
                <span className={styles.dropdownSectionTitle}>
                    {language === 'en' ? 'Select Report Period' : 'अहवाल कालावधी निवडा'}
                </span>


                <button
                    className={styles.dropdownItem}
                    onClick={handleDownloadDailyCashReport}
                >
                    {language === 'en' ? 'Daily Cash' : 'दैनिक रोख'}
                </button>



                <button
                    className={styles.dropdownItem}
                    onClick={() => handleDownload("previous")}
                >
                    {language === 'en' ? 'Previous Month' : 'मागील महिना'}
                </button>

                <button
                    className={styles.dropdownItem}
                    onClick={() => handleDownload("current")}
                >
                    {language === 'en' ? 'This Month' : 'हा महिना'}
                </button>
                <button
                    className={styles.dropdownItem}
                    onClick={() => console.log('this_year')}
                >
                    {language === 'en' ? 'This Year' : 'हे वर्ष'}
                </button>
            </div>
            {/* ... keep existing columns menu content */}
        </div>
    ), [activeDropdown, currentLanguageConfig.columns, columnVisibility, language, toggleColumn]);



    const renderReportMenu = useCallback(() => (
        <div
            ref={reportRef}
            className={`${styles.dropdownContent} ${activeDropdown === 'report' ? styles.show : ''}`}
        >
            <div className={styles.dropdownSection}>
                <span className={styles.dropdownSectionTitle}>
                    {language === 'en' ? 'Daily Reports' : 'दैनिक अहवाल'}
                </span>

                <button
                    className={styles.dropdownItem}
                    onClick={handleDownloadDailyCashReport}
                >
                    {language === 'en' ? 'Today\'s Cash Report' : 'आजचा रोख अहवाल'}
                </button>

                <button
                    className={styles.dropdownItem}
                    onClick={handlePreviousDayCashReport}
                >
                    {language === 'en' ? 'Previous Day Cash Report' : 'मागील दिवसाचा रोख अहवाल'}
                </button>
            </div>

            <div className={styles.dropdownSection}>
                <span className={styles.dropdownSectionTitle}>
                    {language === 'en' ? 'Monthly Reports' : 'मासिक अहवाल'}
                </span>

                <button
                    className={styles.dropdownItem}
                    onClick={handlePreviousMonthCashReport}
                >
                    {language === 'en' ? 'Previous Month Cash Report' : 'मागील महिन्याचा रोख अहवाल'}
                </button>
                {/* 
                <button
                    className={styles.dropdownItem}
                    onClick={() => handleDownload("previous")}
                >
                    {language === 'en' ? 'Previous Month Summary' : 'मागील महिन्याचा सारांश'}
                </button>

                <button
                    className={styles.dropdownItem}
                    onClick={() => handleDownload("current")}
                >
                    {language === 'en' ? 'This Month Summary' : 'चालू महिन्याचा सारांश'}
                </button> */}
            </div>
        </div>
    ), [activeDropdown, language, handleDownloadDailyCashReport, handlePreviousDayCashReport, handlePreviousMonthCashReport, handleDownload]);
    return (
        <div className={styles.tableContainer}>
            {/* Header Section */}
            <div className={styles.tableHeader}>
                <div className={styles.searchContainer}>
                    <FaSearch className={styles.searchIcon} />
                    <input
                        type="text"
                        placeholder={currentLanguageConfig.uiText.searchPlaceholder}
                        className={styles.search}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                {/* Status Summary - New section added here */}
                <div className={styles.statusSummary}>
                    {currentLanguageConfig.uiText.statusSummary
                        .replace('{approvedCount}', totalApprovedApplications)
                        .replace('{totalCount}', totalApplications)}
                </div>

                {/* Table Controls */}
                <div className={styles.actionsContainer}>

                    {/* Village area Controls */}
                    {/* <div className={styles.dropdown}>
                        <button
                            className={`${styles.actionButton} ${activeDropdown === 'villageArea' ? styles.active : ''}`}
                            onClick={toggleVillageAreaMenu}
                        >
                            Village Area
                            {activeDropdown === 'villageArea' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                        </button>
                        {renderVillageAreaMenu()}
                    </div> */}

                    {/* Language Controls */}
                    <div className={styles.dropdown}>
                        <button
                            className={`${styles.actionButton} ${activeDropdown === 'language' ? styles.active : ''}`}
                            onClick={toggleLanguageMenu}
                        >
                            <FaLanguage /> {currentLanguageConfig.uiText.language}
                            {activeDropdown === 'language' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                        </button>
                        {renderLanguageMenu()}
                    </div>

                    {/* Filter Controls */}
                    <div className={styles.dropdown}>
                        <button
                            className={`${styles.actionButton} ${activeDropdown === 'filter' ? styles.active : ''}`}
                            onClick={toggleFilterMenu}
                        >
                            <FaFilter /> {currentLanguageConfig.uiText.filter} {activeFilters.length > 0 && `(${activeFilters.length})`}
                            {activeDropdown === 'filter' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                        </button>
                        {renderFilterMenu()}
                    </div>

                    {/* Column Visibility Controls */}
                    <div className={styles.dropdown}>
                        <button
                            className={`${styles.actionButton} ${activeDropdown === 'columns' ? styles.active : ''}`}
                            onClick={toggleColumnsMenu}
                        >
                            <FaColumns /> {currentLanguageConfig.uiText.columns}
                            {activeDropdown === 'columns' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                        </button>
                        {renderColumnsMenu()}
                    </div>

                    {/* report genreation */}
                    <div className={styles.dropdown}>
                        <button
                            className={`${styles.actionButton} ${activeDropdown === 'report' ? styles.active : ''}`}
                            onClick={toggleReportMenu}
                        >
                            <FaColumns /> Report
                            {activeDropdown === 'report' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                        </button>
                        {renderReportMenu()}
                    </div>
                    <MonthlyReportPDF ref={pdfRefPre} reportInfo={reportInfoPre} tableData={tableData_report_prev} />
                    <MonthlyReportPDF ref={pdfRef} reportInfo={reportInfo} tableData={tableData_report} />
                    <DailyCashReportPDF
                        ref={dailyCashReportRef}
                        reportData={{
                            date: new Date().toLocaleDateString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            }),
                            zone: { count: 0, records: [] },
                            partplan: { count: 0, records: [] },
                            payment: { online: { count: 0, amount: 0 }, cash: { count: 0, amount: 0 } },
                            remarks: ""
                        }}
                    />
                    {/* Add after existing PDF components */}
                    <PreviousCashReportPDF ref={previousDayCashReportRef} />
                    <PreviousCashReportPDF ref={previousMonthCashReportRef} />
                </div>
            </div>

            {/* Applications Table */}
            {isLoading ? (
                <div className={styles.loadingState}>
                    <div className={styles.loadingSpinner} />
                </div>
            ) : displayApplications.length === 0 ? (
                <div className={styles.emptyState}>
                    <div className={styles.emptyStateIcon}>
                        <FaSearch size={48} />
                    </div>
                    <h3 className={styles.emptyStateTitle}>{currentLanguageConfig.uiText.noResultsTitle}</h3>
                    <p className={styles.emptyStateDescription}>
                        {currentLanguageConfig.uiText.noResultsDescription(searchQuery || activeFilters.length > 0)}
                    </p>
                </div>
            ) : (
                <table className={styles.table}>
                    {renderTableHeader()}
                    {renderTableBody()}
                </table>
            )}

            {/* Edit Modal */}
            {isEditModalOpen && selectedRecord && (
                <EditModal
                    selectedRecord={selectedRecord}
                    closeEditModal={closeEditModal}
                    saveRecordChanges={saveRecordChanges}
                    language={language}
                    officerProfile={officerProfile}
                    signPath={signPath}
                />
            )}

        </div>
    );
};

export default OfficeTable;